import React from 'react'
import ProfileSvg from 'images/modules/Manage/i-menu-profile.svg?raw'

export { default as ProfileUrl } from 'images/modules/Manage/i-menu-profile.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: ProfileSvg}} />
)
